__turbopack_context__.v({
  "administrationFeatures": "features-module-scss-module__wvl24q__administrationFeatures",
  "analyticsFeatures": "features-module-scss-module__wvl24q__analyticsFeatures",
  "feature": "features-module-scss-module__wvl24q__feature",
  "featureIcon": "features-module-scss-module__wvl24q__featureIcon",
  "featureTitle": "features-module-scss-module__wvl24q__featureTitle",
  "fileAccessFeatures": "features-module-scss-module__wvl24q__fileAccessFeatures",
  "securityFeatures": "features-module-scss-module__wvl24q__securityFeatures",
  "supportFeatures": "features-module-scss-module__wvl24q__supportFeatures",
});
